import classNames from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/ImageV2';
import { IMAGE_RATIOS, IMAGE_WIDTHS } from 'constants/images';

const ImagePairCopyImage = ({ desktopImage, className }) => (
  <div className={classNames('ImagePairCopyImage', className)}>
    <Image
      className="ImagePairCopy__image"
      src={get(desktopImage, ['file', 'url'])}
      alt={get(desktopImage, ['description'], '')}
      width={IMAGE_WIDTHS.W_1200}
      ratio={IMAGE_RATIOS.R_5x6}
    />
  </div>
);

const imagePropType = PropTypes.shape({
  file: PropTypes.shape({
    url: PropTypes.string,
  }),
  description: PropTypes.string,
});

ImagePairCopyImage.propTypes = {
  desktopImage: imagePropType.isRequired,
  mobileImage: imagePropType,
  className: PropTypes.string,
};

ImagePairCopyImage.defaultProps = {
  mobileImage: null,
  className: '',
};

export default ImagePairCopyImage;
